import './App.css';
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from 'react-router-dom';

// Page imports
import Home from './pages/Home';
import SignUp from './pages/SignUp';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ReportLost from './pages/ReportLost';
import ItemCollection from './pages/ItemCollection';
import SubmitClaim from './pages/SubmitClaim';
import TrackClaim from './pages/TrackClaim';
import AdminDashboard from './pages/AdminDashboard';
import SecurityDashboard from './pages/SecurityDashboard';
import SecurityLogin from './pages/SecurityLogin';
import AllLostItems from './pages/AllLostItems';
import WelcomePage from './pages/WelcomePage';
import LostItems from './pages/LostItems';
import FoundItems from './pages/FoundItems';
import ItemMatcher from './pages/ItemMatcher';
import AddSecurity from './pages/AddSecurity';
import SystemReport from './pages/SystemReport';
import AboutUs from './pages/AboutUs';
import Approved from './pages/Approved';
import Rejected from './pages/Rejected';
import FAQsPage from './pages/FAQsPage';
import ClientDashboard from './pages/ClientDashboard';
import Notifications from './pages/Notifications'; // ✅ Corrected import

// Components
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import PrivateRoute from './components/PrivateRoute';

const Layout = ({ children }) => {
  const location = useLocation();
  const hideSidebar = [
    '/',
    '/welcome',
    '/login',
    '/signup',
    '/security-login',
    '/about',
    '/faqs',
  ].includes(location.pathname);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <div style={{ display: 'flex', flex: 1 }}>
        {!hideSidebar && <Sidebar />}
        <div style={{ flex: 1, padding: '2rem', backgroundColor: '#e0e0e0' }}>
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
};

const AppRoutes = () => {
  const isSecurityLoggedIn = sessionStorage.getItem('securityCode');

  return (
    <Layout>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<WelcomePage />} />
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/security-login" element={<SecurityLogin />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/faqs" element={<FAQsPage />} />

        {/* Auth Protected Routes */}
        <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/report-lost" element={<PrivateRoute><ReportLost /></PrivateRoute>} />
        <Route path="/item-collection" element={<PrivateRoute><ItemCollection /></PrivateRoute>} />
        <Route path="/submit-claim" element={<PrivateRoute><SubmitClaim /></PrivateRoute>} />
        <Route path="/track-claim" element={<PrivateRoute><TrackClaim /></PrivateRoute>} />
        <Route path="/admin-dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
        <Route path="/all-lost-items" element={<PrivateRoute><AllLostItems /></PrivateRoute>} />
        <Route path="/lost-items" element={<PrivateRoute><LostItems /></PrivateRoute>} />
        <Route path="/found-items" element={<PrivateRoute><FoundItems /></PrivateRoute>} />
        <Route path="/item-matcher" element={<PrivateRoute><ItemMatcher /></PrivateRoute>} />
        <Route path="/add-security" element={<PrivateRoute><AddSecurity /></PrivateRoute>} />
        <Route path="/system-report" element={<PrivateRoute><SystemReport /></PrivateRoute>} />
        <Route path="/client-dashboard" element={<PrivateRoute><ClientDashboard /></PrivateRoute>} />
        <Route path="/notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} /> {/* ✅ Corrected route */}

        {/* Security Protected Routes */}
        <Route
          path="/security-dashboard"
          element={isSecurityLoggedIn
            ? <SecurityDashboard />
            : <Navigate to="/security-login" replace />}
        />
        <Route
          path="/approved"
          element={isSecurityLoggedIn
            ? <Approved />
            : <Navigate to="/security-login" replace />}
        />
        <Route
          path="/rejected"
          element={isSecurityLoggedIn
            ? <Rejected />
            : <Navigate to="/security-login" replace />}
        />
      </Routes>
    </Layout>
  );
};

const App = () => {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default App;
